import { render, staticRenderFns } from "./OrdersDetailModal.vue?vue&type=template&id=0c04102f"
import script from "./OrdersDetailModal.vue?vue&type=script&lang=js"
export * from "./OrdersDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports